import { Expose, Type } from "class-transformer";
import CastRes from "types/res/cast/CastRes";
import OptionRes from "types/res/option/OptionRes";
import NotelClassRes from "types/res/notelClass/NotelClassRes";
import ShopRes from "types/res/shop/ShopRes";

export default class CastNameRes {
  @Expose() readonly castNameId!: number;
  @Expose() readonly companyId!: number;
  @Expose() readonly castId!: number;
  @Expose() readonly name!: string;
  @Expose() readonly shopId!: number;
  @Expose() readonly notelClassId!: number;
  @Type(() => ShopRes)
  @Expose()
  readonly shop!: ShopRes;
  @Type(() => NotelClassRes)
  @Expose()
  readonly notelClass!: NotelClassRes;
  @Type(() => CastRes)
  @Expose()
  readonly cast!: CastRes;
  @Type(() => OptionRes)
  @Expose()
  readonly options!: OptionRes[];
}
